export default __webpack_public_path__ + "static/media/PierceCDice.78998ce2.png";